import React from "react";
import { Link } from "react-router-dom";
import { Home, ArrowRight } from "lucide-react";

const NotFoundPage = () => (
  <main className="bg-cream min-h-[60vh] flex items-center">
    <div className="max-w-2xl mx-auto text-center px-6 py-16">
      <div className="font-serif-brand text-[120px] leading-none font-bold text-brand">404</div>
      <h1 className="font-serif-brand text-3xl font-bold text-[#2a1a15]">Page not found</h1>
      <p className="mt-2 text-[#6b4f39]">Looks like this page went nutty. Let's get you back home.</p>
      <div className="mt-6 flex items-center justify-center gap-3">
        <Link to="/" className="inline-flex items-center gap-2 bg-brand hover:bg-[#6c1414] text-white font-semibold px-6 py-3 rounded-full transition-colors">
          <Home className="h-4 w-4" /> Home
        </Link>
        <Link to="/shop" className="inline-flex items-center gap-2 border border-[#3a2a20] text-[#2a1a15] hover:bg-[#2a1a15] hover:text-white font-medium px-6 py-3 rounded-full transition-colors">Shop <ArrowRight className="h-4 w-4" /></Link>
      </div>
    </div>
  </main>
);

export default NotFoundPage;
